export enum MsTeamsProvisioningActionEnum
{
    GrantMsAdminConsent=1,
    CreateRecordingPolicy=2,
    AssignRecordingPolicyToUsers=3
}